import { gql } from '@apollo/client'

export type UserProfileAttributesFragment = {
  firstName: string
  lastName: string
  lanId: string
  companyName: string
  email: string
  partnerId?: number | null
  accreditations: Array<{
    code: string
    description: string
    status: string
  }>
  id: string
  active: boolean
  betaTester: boolean
  internal: boolean
  primaryRole?: number
  theme?: string
  currentVMMRole?: number
  notificationAttributes?: {
    optedBatching: boolean
    optedOutNotifications: string[]
  }
  notificationTypes?: string[]
  outOfOfficeAttributes?: {
    oooFromDate?: string
    oooMessage?: string
    oooToDate?: string
    userOutOfOffice?: boolean
  }
}

export const USER_PROFILE_ATTRIBUTES_FRAGMENT = gql`
  fragment UserProfileAttributes on UserProfileAttributes {
    firstName
    lastName
    lanId
    companyName
    email
    partnerId
    accreditations {
      code
      description
      status
    }
    id
    active
    betaTester
    internal
    primaryRole
    theme
    currentVMMRole
    notificationAttributes {
      optedBatching
      optedOutNotifications
    }
    notificationTypes
    outOfOfficeAttributes {
      oooFromDate
      oooMessage
      oooToDate
      userOutOfOffice
    }
  }
`
